
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/engineers/job-openings/[...slugs]",
      function () {
        return require("private-next-pages/engineers/job-openings/[...slugs].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/engineers/job-openings/[...slugs]"])
      });
    }
  